import { Grid, Button, CircularProgress, Icon } from '@material-ui/core';
import { Formik, Form, Field } from 'formik';
import React, { useCallback, useEffect } from 'react';
import { useObservable } from 'react-use-observable';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { SelectProduct } from 'v2/components/Shared/FormFields/SelectProduct';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import ordersService from 'v2/services/orders';

import initialValues, { CustomerTypes, InvoiceStatus, PaymentTypes, ECustomerSearchTypes } from './initialValues';
import { useStyles } from './styles';
import FilterSchema from './validations';

import type { FormikProps } from 'formik';

const Filter = () => {
  const classes = useStyles();
  useEffect(() => {
    ordersService.loadOrderStatus();
  }, []);

  const [isLoading] = useObservable(() => ordersService.isLoading(), []);

  const [orderStatus] = useObservable(() => ordersService.getOrderStatus(), []);

  const onSubmit = useCallback((values: typeof initialValues, { setSubmitting }: FormikProps<typeof initialValues>) => {
    ordersService.setFilter({ ...values });
    setSubmitting(false);
  }, []);

  return (
    <Formik initialValues={initialValues} validationSchema={FilterSchema} onSubmit={onSubmit}>
      {({ isValid, isSubmitting, dirty, resetForm, values, setFieldValue }: FormikProps<typeof initialValues>) => {
        const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
          const v = e.target.value;
          setFieldValue('customer', '');
          setFieldValue('customer_type', v);
        };

        const onChangeInvoice = (e: React.ChangeEvent<HTMLInputElement>) => {
          const v = e.target.value;
          let value = null;
          if (v && !isNaN(Number(v))) value = v;
          setFieldValue('invoice_id', value);
        };

        return (
          <Form id='sales-filter' className={classes.root}>
            <div>
              <Grid container xs={12} spacing={1}>
                <Grid item xs={12} sm={6} md={4} xl={2}>
                  <Field label='Período' id='date' name='date' component={DateRangePickerFormField} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={2}>
                  <Grid container>
                    <Grid item xs={4}>
                      <Field
                        id='customer_type'
                        name='customer_type'
                        label='Cliente'
                        inputProps={{
                          className: classes.leftInput,
                        }}
                        fullWidth
                        options={CustomerTypes}
                        component={SelectFormField}
                        onChange={onChangeCustomerType}
                      />
                    </Grid>
                    <Grid item xs={8}>
                      <Field
                        id='customer'
                        name='customer'
                        component={TextFormField}
                        inputProps={{
                          className: classes.rightInput,
                        }}
                        fullWidth
                        label={
                          values.customer_type == ECustomerSearchTypes.DOCUMENT
                            ? 'CPF/CNPJ'
                            : values.customer_type == ECustomerSearchTypes.EMAIL
                            ? 'E-mail'
                            : 'Nome'
                        }
                        placeholder={
                          values.customer_type == ECustomerSearchTypes.NAME
                            ? 'Insira o nome'
                            : values.customer_type == ECustomerSearchTypes.EMAIL
                            ? 'Insira o e-mail'
                            : 'Insira o CPF/CNPJ'
                        }
                        mask={values.customer_type == ECustomerSearchTypes.DOCUMENT ? 'document' : null}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={1}>
                  <Field
                    type={'tel'}
                    label='Fatura'
                    onChange={onChangeInvoice}
                    fullWidth
                    id='invoice_id'
                    name='invoice_id'
                    mask='number'
                    component={TextFormField}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={1}>
                  <Field
                    id='product_id'
                    name='product_id'
                    fullWidth
                    hasLabel
                    endpoint='/reports/filter-physical-products'
                    component={SelectProduct}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={1}>
                  <Field
                    id='payment_status'
                    name='payment_status'
                    multiple
                    options={InvoiceStatus}
                    fullWidth
                    label='Status da fatura'
                    component={SelectFormField}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={1}>
                  <Field id='status' fullWidth multiple name='status' options={orderStatus} label='Status da entrega' component={SelectFormField} />
                </Grid>
                <Grid item xs={12} sm={6} md={4} xl={2}>
                  <Field
                    id='payment_method'
                    fullWidth
                    multiple
                    name='payment_method'
                    options={PaymentTypes}
                    label='Tipo de pagamento'
                    component={SelectFormField}
                  />
                </Grid>
                <Grid item xs={12} md={4} xl={1} className={classes.buttonContainer}>
                  <Button
                    id='clear-button'
                    disabled={!dirty || isSubmitting || isLoading}
                    color='primary'
                    fullWidth
                    onClick={() => resetForm({ values: initialValues })}
                  >
                    <span id='clear-button-label'>Limpar</span>
                    {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
                  </Button>
                </Grid>
                <Grid item xs={12} md={4} xl={1} className={classes.buttonContainer}>
                  <Button
                    id='basic-filter-button'
                    variant='contained'
                    disabled={!isValid || isSubmitting || isLoading}
                    color='secondary'
                    fullWidth
                    type='submit'
                  >
                    <Icon id='basic-filter-button-icon' style={{ marginRight: '0.5rem', fontSize: 14 }}>
                      filter_list
                    </Icon>{' '}
                    <span id='basic-filter-button-label'>Filtrar</span>
                    {(isLoading || isSubmitting) && <CircularProgress size={10} style={{ color: '#192542', marginLeft: 10 }} />}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
export default Filter;
